import EterIcon from '../../assets/icons/eter-orange.svg'
import AireIcon from '../../assets/icons/aire-orange.svg'
import AguaIcon from '../../assets/icons/agua-orange.svg'
import FuegoIcon from '../../assets/icons/fuego-orange.svg'
import TierraIcon from '../../assets/icons/tierra-orange.svg'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import { Helmet } from 'react-helmet'
import WhatsAppButton from '../../components/WhatsAppButton'
import Banner from '../../components/Banner'

const formatPrice = (price) => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price)
}

const PLANS = [
  {
    title: 'Plan tierra',
    description: 'Cinco días por semana.',
    image: TierraIcon,
    weekDays: {
      full: 5,
      part: 5
    },
    credits: {
      full: 40,
      part: 20
    },
    hours: {
      full: 12,
      part: 7
    },
    price: {
      full: 460100,
      part: 286100
    }
  }, {
    title: 'Plan fuego',
    description: 'Cuatro días por semana.',
    image: FuegoIcon,
    weekDays: {
      full: 4,
      part: 4
    },
    credits: {
      full: 32,
      part: 16
    },
    hours: {
      full: 10,
      part: 6
    },
    price: {
      full: 405900,
      part: 236100
    }
  }, {
    title: 'Plan agua',
    description: 'Tres días por semana.',
    image: AguaIcon,
    weekDays: {
      full: 3,
      part: 3
    },
    credits: {
      full: 24,
      part: 12
    },
    hours: {
      full: 8,
      part: 5
    },
    price: {
      full: 314600,
      part: 208100
    }
  }, {
    title: 'Plan aire',
    description: 'Dos días por semana.',
    image: AireIcon,
    weekDays: {
      full: 2,
      part: 2
    },
    credits: {
      full: 16,
      part: 8
    },
    hours: {
      full: 6,
      part: 4
    },
    price: {
      full: 236100,
      part: 153800
    }
  }, {
    title: 'Plan eter',
    description: 'Un día por semana.',
    image: EterIcon,
    weekDays: {
      full: 1,
      part: 1
    },
    credits: {
      full: 8,
      part: 4
    },
    hours: {
      full: 5,
      part: 3
    },
    price: {
      full: 153800,
      part: 134400
    }
  }
]

const Plans = () => {
  return (
    <>
      <Helmet>
        <title>Vida Cowork: Planes</title>
      </Helmet>

      <main className="Plans mb-5">
        <Banner
          title='Nuestros planes'
          description='Trabajá en un espacio vivo que impulsa tu creatividad. Ambientes amplios, conexión constante y sinergia en cada jornada laboral.'
          message='¡Hola! Quisiera contratar un plan en Vida'
          titleFullWidth
          whatsappIconLeft
          contact='5493513548319'
        />
        <div className="container-custom Plans__Container">
          <span className='title-2 text-green'>Nuestros horarios</span>
          <div className="Plans__Time-Container">
            <div className="Plans__Time-Items">
              <div className="d-flex flex-column gap-1">
                <span className="text-orange text-3 fw-bold">Full time</span>
                <span className="text-4 text-gray-dark fw-bold">De 8:00 a 18:30 hs</span>
              </div>
              <div className="d-flex flex-column gap-1">
                <span className="text-orange text-3 fw-bold">Part time</span>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-4 text-gray-dark fw-bold">De 8:00 a 13:00 hs</span>
                  <span className="text-4 text-gray-dark fw-bold">De 13:30 a 18:30 hs</span>
                </div>
              </div>
              <div className="d-flex flex-column gap-1">
                <span className="text-orange text-3 fw-bold">Atención</span>
                <span className="text-4 text-gray-dark fw-bold">
                  Todos los planes incluyen horas en salas de reunión
                </span>
              </div>
            </div>
          </div>

          <div className="Plans__List">
            <div className="Plans__Header d-none d-lg-grid">
              <span className="text-4 fw-medium text-center">Plan</span>
              <span className="text-4 fw-medium text-center">Días a la semana</span>
              <span className="text-4 fw-medium text-center">Full/Part</span>
              <span className="text-4 fw-medium text-center">Créditos</span>
              <span className="text-4 fw-medium text-center">Hs en salas</span>
              <span className="text-4 fw-medium text-center">Valor en $ARS</span>
            </div>

            {PLANS.map((plan, index) => (
              <div key={`Plans-Item-${index}`} className="Plans__Item d-none d-lg-grid">
                <div className="Plans__Item-Title">
                  <div className="d-flex align-items-center gap-2">
                    <img src={plan.image} alt={plan.title} title={plan.title} />

                    <span className="text-1 fw-semibold">{plan.title}</span>
                  </div>

                  <span className="d-block text-5 text-center d-lg-none d-block">
                    {plan.description}
                  </span>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data fst-italic">{plan.weekDays.full}</div>
                  <div className="Plans__Item-Data fst-italic">{plan.weekDays.part}</div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data fst-italic">Full</div>
                  <div className="Plans__Item-Data fst-italic">Part</div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data fst-italic">{plan.credits.full}</div>
                  <div className="Plans__Item-Data fst-italic">{plan.credits.part}</div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data fst-italic">{plan.hours.full}</div>
                  <div className="Plans__Item-Data fst-italic">{plan.hours.part}</div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data fst-italic">
                    {plan.price.full && formatPrice(plan.price.full)}
                  </div>
                  <div className="Plans__Item-Data fst-italic">{formatPrice(plan.price.part)}</div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data">
                    <WhatsAppButton
                      label='Adquirir plan'
                      message={`¡Hola! Quisiera contratar el ${plan.title} en Vida`}
                      withIconLeft
                      contact='5493513548319'
                    />
                  </div>
                  <div className="Plans__Item-Data">
                    <WhatsAppButton
                      label='Adquirir plan'
                      message={`¡Hola! Quisiera contratar el ${plan.title} en Vida`}
                      withIconLeft
                      contact='5493513548319'
                    />
                  </div>
                </div>
              </div>
            ))}

            {PLANS.map((plan, index) => (
              <div key={`Plans-Item-${index}`} className="Plans__Item d-flex d-lg-none">
                <div className="Plans__Item-Title">
                  <img src={plan.image} alt={plan.title} title={plan.title} />

                  <span className="text-1 fw-semibold">{plan.title}</span>

                  <span className="d-block text-5 text-center">{plan.description}</span>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data fst-italic bg-white text-center">Tipo</div>
                  <div className="Plans__Item-Data fst-italic bg-white text-center">Créditos</div>
                  <div className="Plans__Item-Data fst-italic bg-white text-center">
                    Horas en salas
                  </div>
                  <div className="Plans__Item-Data fst-italic bg-white text-center">
                    Valor en $RS
                  </div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold ms-1">Full</span>
                  </div>
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold ms-1">{plan.credits.full}</span>
                  </div>
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold me-1">{plan.hours.full}</span> hs
                  </div>
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold me-1">{formatPrice(plan.price.full)}</span>
                  </div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data">
                    <WhatsAppButton
                      label='Adquirir plan'
                      message={`¡Hola! Quisiera contratar el ${plan.title} en Vida`}
                      withIconLeft
                      contact='5493513548319'
                    />
                  </div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold ms-1">Part</span>
                  </div>
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold ms-1">{plan.credits.part}</span>
                  </div>
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold me-1">{plan.hours.part}</span> hs
                  </div>
                  <div className="Plans__Item-Data text-6">
                    <span className="text-3 fw-bold me-1">{formatPrice(plan.price.part)}</span>
                  </div>
                </div>

                <div className="Plans__Item-Content">
                  <div className="Plans__Item-Data">
                    <WhatsAppButton
                      label='Adquirir plan'
                      message={`¡Hola! Quisiera contratar el ${plan.title} en Vida`}
                      withIconLeft
                      contact='5493513548319'
                    />
                  </div>
                </div>
              </div>
            ))}

            <span className="text-black fst-italic text-5">(*) los valores no incluyen IVA</span>
          </div>
        </div>
      </main>
    </>
  )
}

export default Plans
